export const CREATE_PORTFOLIO = '@DASHBOARD/CREATE_PORTFOLIO'
export const GET_ALL_CUSTOMER = '@DASHBOARD/GET_ALL_CUSTOMER'
export const GET_PORTFOLIO_BY_USERID = '@DASHBOARD/GET_PORTFOLIO_BY_USERID'
export const GET_PORTFOLIO_BY_USERID_AFTER_ACTION_CRUD = '@DASHBOARD/GET_PORTFOLIO_BY_USERID_AFTER_ACTION_CRUD'
export const DELETE_PORTFOLIO_BY_ID = '@DASHBOARD/DELETE_PORTFOLIO_BY_ID'
export const GET_PORTFOLIO_BY_ID_EDIT = '@DASHBOARD/GET_PORTFOLIO_BY_ID_EDIT'
export const GET_PORTFOLIO_BY_ID = '@DASHBOARD/GET_PORTFOLIO_BY_ID'
export const UPDATE_TIME_IPO = '@DASHBOARD/UPDATE_TIME_IPO'
export const GET_ASSET_GOALS = '@DASHBOARD/GET_ASSET_GOALS'
export const GET_GROWTH_SCHEDULES = '@DASHBOARD/GET_GROWTH_SCHEDULES'
export const UPDATE_ASSET_GOALS = '@DASHBOARD/UPDATE_ASSET_GOALS'
export const UPDATE_GROWTH_SCHEDULES = '@DASHBOARD/UPDATE_GROWTH_SCHEDULES'
export const GET_ALL_ROLES_PERMISSION = '@DASHBOARD/GET_ALL_ROLES_PERMISSION'
export const GET_ALL_MEMBER_IN_PORTFOLIO = '@DASHBOARD/GET_ALL_MEMBER_IN_PORTFOLIO'
export const POST_INVITE_MEMBER_PORTFOLIO = '@DASHBOARD/POST_INVITE_MEMBER_PORTFOLIO'
export const POST_ACCEPTED_INVITE_MEMBER_PORTFOLIO = '@DASHBOARD/POST_ACCEPTED_INVITE_MEMBER_PORTFOLIO'
export const GET_VERIFY_INVITE_MEMBER_PORTFOLIO = '@DASHBOARD/GET_VERIFY_INVITE_MEMBER_PORTFOLIO'
export const DELETE_MEMBER_PORTFOLIO = '@DASHBOARD/DELETE_MEMBER_PORTFOLIO'
export const UPDATE_PORTFOLIO_NAME = '@DASHBOARD/UPDATE_PORTFOLIO_NAME'
export const RESET_REDUCER = '@DASHBOARD/RESET_REDUCER'
export const SET_EMPTY_PORTFOLIO_BY_ID = '@DASHBOARD/SET_EMPTY_PORTFOLIO_BY_ID'
export const UPDATE_CURRENCY = '@DASHBOARD/UPDATE_CURRENCY'
